import React from "react";
import { useNavigate } from "react-router-dom";
import { Container, Grid, Typography, Box } from "@mui/material";
import dayjs from "dayjs";
import useStyles from "./styles";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import CeroItemPair from "../../../../../components/CeroItemPair";
import CeroInfoPair from "../../../../../components/CeroInfoPair";

const AntiCompetitiveDisclosure = (props) => {
  const classes = useStyles();
  const navigate = useNavigate();
  const { emissionData } = props;

  return (
    <>
      <div
        className={classes.backContainer}
        onClick={() => {
          navigate(-1);
        }}
      >
        <ArrowBackIosIcon />
        Back
      </div>
      <Container className={classes.container}>
        <Box className={classes.innerContainer}>
          <Box className={classes.header}>
            <Typography variant="h6" component="div">
              Anti Competitive Disclosure
            </Typography>
          </Box>
          <Box className={classes.topContainer}>
            <Grid
              container
              direction={"row"}
              wrap="nowrap"
              justifyContent={"space-between"}
              display={"contents"}
              spacing={12}
            >
              <Grid
                item
                container
                direction={"column"}
                display={"contents"}
                xs={10}
              >
                <Box className={classes.actionBox}>
                  <CeroInfoPair
                    title="Status:"
                    value={emissionData.status ? emissionData.status : "NA"}
                    classes={{
                      container: classes.statusContainer,
                      title: classes.statusTitle,
                      value:
                        emissionData.status === "In Progress"
                          ? classes.Inprogress
                          : classes[emissionData?.status],
                    }}
                  />
                </Box>
                <CeroItemPair
                  title="Facility:"
                  value={
                    emissionData.facility_name
                      ? emissionData.facility_name
                      : "NA"
                  }
                  classes={{
                    container: classes.infoContainer,
                    title: classes.antiCorruptionDisclosure,
                    value: classes.value,
                  }}
                />
                <CeroItemPair
                  title="Period:"
                  value={
                    emissionData.assessment_period
                      ? emissionData.assessment_period
                      : "NA"
                  }
                  classes={{
                    container: classes.infoContainer,
                    title: classes.antiCorruptionDisclosure,
                    value: classes.value,
                  }}
                />
                <CeroItemPair
                  title="Year:"
                  value={emissionData.year ? emissionData.year : "NA"}
                  classes={{
                    container: classes.infoContainer,
                    title: classes.antiCorruptionDisclosure,
                    value: classes.value,
                  }}
                />
                <CeroItemPair
                  title="Number of legal actions:"
                  value={emissionData.number_of_legal_action || "NA"}
                  classes={{
                    container: classes.infoContainer,
                    title: classes.antiCorruptionDisclosure,
                    value: classes.value,
                  }}
                />
                <CeroItemPair
                  title="Describe the main outcomes of completed legal actions, including any decisions or judgments:"
                  value={emissionData.outcomes_of_legal_action || "NA"}
                  classes={{
                    container: classes.infoContainer,
                    title: classes.antiCorruptionDisclosure,
                    value: classes.value,
                  }}
                />
                <CeroItemPair
                  title="Corrective Action:"
                  value={emissionData.corrective_action || "NA"}
                  classes={{
                    container: classes.infoContainer,
                    title: classes.antiCorruptionDisclosure,
                    value: classes.value,
                  }}
                />
                <CeroItemPair
                  title="Audited on:"
                  value={
                    emissionData.audited_by ? emissionData.audited_by : "NA"
                  }
                  classes={{
                    container: classes.infoContainer,
                    title: classes.antiCorruptionDisclosure,
                    value: classes.value,
                  }}
                />
                <CeroItemPair
                  title="Audited by:"
                  value={
                    emissionData.audited_on
                      ? dayjs(emissionData.audited_on).format("DD/MM/YYYY")
                      : "NA"
                  }
                  classes={{
                    container: classes.infoContainer,
                    title: classes.antiCorruptionDisclosure,
                    value: classes.value,
                  }}
                />
              </Grid>
            </Grid>
          </Box>
        </Box>
      </Container>
    </>
  );
};

export default AntiCompetitiveDisclosure;
